import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { INSIGHT_THREAT_TYPES_REQUEST_ASYNC } from './InsightWidget/constants'
import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from './constants'

const initialState = {
  dateFilter: DATE_VALUES.WEEK,
  dateRange: getRangeFromDateFilter(DATE_VALUES.WEEK),
  withoutScanback: false,
  threatTypes: null,
  threatTypesLoader: false,
  threatTypesError: null,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.value,
          feDateRange: getRangeFromDateFilter(action.payload.value),
        }
      case SCANBACK_CHANGE:
        return { ...state, withoutScanback: action.payload }
      case INSIGHT_THREAT_TYPES_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          threatTypesLoader: true,
          threatTypesError: null,
        }
      case INSIGHT_THREAT_TYPES_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          threatTypes: action.payload,
          threatTypesLoader: false,
          threatTypesError: null,
        }
      case INSIGHT_THREAT_TYPES_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          threatTypesLoader: false,
          threatTypesError: action.error,
        }
      case INSIGHT_THREAT_TYPES_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          threatTypesLoader: false,
        }
      default:
        return state
    }
  }
}
